import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { hideModal as hideModalAction } from 'actions/modalActions';
import { usePressEscape } from 'hooks';
import NoExtension from 'modules/request/components/noExtension';
import * as templateContent from 'enums/templateItemsEnum';

const MissingBookingCategoriesModal = () => {
    const dispatch = useDispatch();

    const hideModal = useCallback(() => {
        dispatch(hideModalAction());
    }, [dispatch]);

    usePressEscape(hideModal);

    return (
        <NoExtension
            {...templateContent.NO_FIXED_COSTS_CATEGORY_GROUPS_EXT}
            onCloseClick={hideModal}
            fullScreen
            newVersionShortId="fixed_costs"
        />
    );
};

MissingBookingCategoriesModal.propTypes = {};

export default MissingBookingCategoriesModal;
